import { type JSX, type PropsWithChildren } from 'react';

import Footer from '../Footer';
import NavigationBar from '../NavigationBar';

import styles from './index.module.css';

/**
 * BaseLayout component that includes NavigationBar and Footer around children components.
 */
export default function BaseLayout({ children }: PropsWithChildren): JSX.Element {
  return (
    <div className={styles['baseLayout']}>
      <NavigationBar />
      <div>{children}</div>
      <Footer />
    </div>
  );
}
